// F7 "Send feedback" (friends-and-family round, 10/08). Astra drafted every line (brief build/astra/copy-feedback-prompt.md,
// output build/astra/copy-feedback.txt); gated by Claude 10/08: sentence case, no exclamation marks, no em or en dashes,
// no "AI", no "listings", every claim in the brief's facts. 19 of 19 passed. Kept in its own file so the feature stays
// self-contained (copy.ts and copyFlow2.ts are being edited on other branches).
const FB = {
  'fb.link': 'Send feedback',
  'fb.title': 'Send feedback',
  'fb.label': 'What would you like us to know?',
  'fb.placeholder': 'What happened? What did you expect?',
  'fb.doing': 'What were you doing? (Optional)',
  'fb.doing_setup': 'Answering first questions',
  'fb.doing_browsing': 'Browsing activities',
  'fb.doing_planning': 'Making a plan',
  'fb.doing_calendar': 'Adding to calendar',
  'fb.doing_other': 'Something else',
  'fb.context': "We include your page, app version, screen size and browser. Your note isn't linked to you, so we can't reply.",
  'fb.send': 'Send',
  'fb.sending': 'Sending',
  'fb.sent_title': 'Thanks for the note',
  'fb.sent_body': 'Your note goes to the people building Magellan. We read every note.',
  'fb.done': 'Done',
  'fb.error': "Your note didn't send. Your text is still here. Try again.",
  'fb.offline': "You look offline. Your text is still here. Try again when you're connected.",
  'fb.too_many': "You've sent several notes in a minute. Please wait a minute before trying again.",
} as const

export type FbKey = keyof typeof FB
export const fb = (k: FbKey): string => FB[k]
